<template>
	<div class="container">
		<!-- 登录 -->
		<div class="login">
			<div class="deng_lu">
				<div class="deng-lu-xuan-zhe">
					<div class="yuan-cheng-jiao-yu" v-show="popActive == 0">
						<router-link to="/">
							<img src="@/assets/logo.png" to="{path:'/'}" alt="" class="logo" />
						</router-link>
					</div>
					<button class="zhang-hao-deng-lu" v-on:click="popTab(1)" v-show="popActive == 0">
						<span class="iconfont icon-zhanghao"></span>
						账号登录
					</button>
					<div class="deng_lu_kuang" v-show="popActive == 1">
						<span class="login-pass-title">账号登录</span>
						<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px"
							@keyup.enter.native="submitForm('ruleForm')" class="demo-ruleForm">
							<el-form-item prop="age">
								<el-input v-model.number="ruleForm.username" placeholder="请输入账号/手机号"></el-input>
							</el-form-item>
							<el-form-item prop="pass">
								<el-input type="password" v-model="ruleForm.password" autocomplete="off"
									placeholder="请输入密码"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="submitForm('ruleForm')" class="an_niu">登录</el-button>
							</el-form-item>
							<div class="JiZhu">
								<el-checkbox style="float:left;" v-model="checked">记住密码</el-checkbox>
								<span class="zhao-hui-mi-ma" @click="popTab(3)">找回密码</span>
							</div>
							<div class="tong-yi">
								<el-checkbox v-model="checkeds">
									<span>已阅读并同意</span>
									<router-link to="/agreement" target=_blank class="xue-yi">《美课教育服务协议》</router-link>
								</el-checkbox>
							</div>
							<div class="back" @click="popTab(0)"> 点此返回</div>
						</el-form>
					</div>
					<div class="deng_lu_kuang" v-show="popActive == 3">
						<span class="login-pass-title">密码找回</span>
						<el-form :model="resetFormData" status-icon :rules="rules" ref="resetForms" label-width="100px"
							class="demo-ruleForm">
							<el-form-item prop="age">
								<el-input type="text" v-model="resetFormData.email" placeholder="请输入账号绑定邮箱"></el-input>
							</el-form-item>
							<el-form-item prop="pass">
								<el-input class="passCode" type="number" v-model="resetFormData.code" autocomplete="off"
									placeholder="请输入验证码">
								</el-input>
								<el-button v-show="codeShow == true" class="getCode" type="primary"
									@click="getCode('resetForms')">
									获取验证码</el-button>
								<el-button v-show="codeShow == false" class="getCode" type="primary"
									@click="resetPass('resetForms')">
									{{count}}后获取
								</el-button>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="resetPass('resetForms')"
									class="an_niu">确认修改</el-button>
							</el-form-item>
							<div class="back" @click="popTab(0)"> 点此返回</div>
						</el-form>
					</div>
					<button class="wei-xin-deng-lu" v-on:click="popTab(2)" v-show="popActive == 0">
						<span class="iconfont icon-wechat"></span>
						微信登录
					</button>
					<div class="wx-login" v-show="popActive == 2">
						<div class="wx-login_div" id="wx_login_container">
							<h3>微信登录</h3>
							<div id="wx_login_container">
							</div>
							<div class="wx-login_info">
								<p>使用微信扫一扫登录</p>
								<p>“美课教育”</p>
							</div>
						</div>
						<div class="back" @click="popTab(0)"> 点此返回</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// let Base64 = require('js-base64').Base64;
	import {
		Base64
	} from "js-base64"
	export default {
		name: 'login',
		data() {
			var checkAge = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请输入账号'))
				}
				callback()
			}
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'))
				} else {
					if (this.ruleForm.checkPass !== '') {
						this.$refs.ruleForm.validateField('checkPass')
					}
					callback()
				}
			}
			return {
				codeShow: true,
				count: 0,
				timer: 0,
				popActive: 0,
				// 记住密码状态
				checked: false,
				// 同意注册协议状态
				checkeds: true,
				// form这里设置了一个对象
				ruleForm: {
					// 登录类型：1.账号登录
					login_type: 1,
					username: '',
					password: ''
				},
				resetFormData: {},
				rules: {
					username: [{
						validator: checkAge,
						trigger: 'blur'
					}],
					password: [{
						validator: validatePass,
						trigger: 'blur'
					}]
				}
			}
		},
		mounted() {
			// 注册监听框架传来的数据
			this.$nextTick(() => {
				// 在外部 Vue 的 window 上添加 postMessage 的监听，并且绑定处理函数 handleMessage
				window.addEventListener('message', this.wechatLoginReturn)
			});
			let username = localStorage.getItem('username')
			if (username) {
				this.ruleForm.username = localStorage.getItem('username')
				this.ruleForm.password = Base64.decode(localStorage.getItem('password')) // base64解密
				this.checked = true
			}
		},

		created() {
			this.wxLogin();
		},
		methods: {
			// 监听微信扫码登陆返回
			wechatLoginReturn(event) {
				const x = event.data
				const data = JSON.parse(x)
				switch (data.cmd) {
					case 'ready-for-receiving': { //接受准备消息
						this.$message.success(data.message) // 判断手段是否成功
						if (data.code == 200) {
							this.$router.push('/')
						}
						break;
					}
				}
			},
			wxLogin() {
				let wxLoginClass = new WxLogin({
					self_redirect: true,
					id: "wx_login_container",
					appid: "wxe244bfaa61a3756b",
					scope: "snsapi_login",
					redirect_uri: encodeURIComponent('https://www.meikesheji.com/#/loginsuccess?type=1'),
				});
			},
			popTab(type) {
				this.popActive = type;
				if (type == 2) {
					this.wxLogin()
				}
			},
			// 获取重置密码验证码
			getCode(formName) {
				this.$refs[formName].validate((valid) => {
					this.$axios({
						method: 'post', // 请求格式
						url: '/api/login/findPass', // 请求路径
						data: this.resetFormData // 请求时携带的参数
					}).then(res => {
						if (res.data.code == 200) {
							this.$message.success(res.data.msg)
							const TIME_COUNT = 60;
							if (this.timer == 0) {
								this.count = TIME_COUNT;
								this.codeShow = false;
								this.timer = setInterval(() => {
									if (this.count > 0 && this.count <= TIME_COUNT) {
										this.count--;
									} else {
										this.codeShow = true;
										clearInterval(this.timer);
										this.timer = 0;
									}
								}, 1000)
							}
						} else {
							this.$message.error(res.data.msg)
						}
					})
				})
			},
			// 确认重置密码
			resetPass(formName) {
				this.$refs[formName].validate((valid) => {
					this.$axios({
						method: 'post', // 请求格式
						url: '/api/login/findPassConfirm', // 请求路径
						data: this.resetFormData // 请求时携带的参数
					}).then(res => {
						if (res.data.code == 200) {
							this.$message.success(res.data.msg)
						} else {
							this.$message.error(res.data.msg)
						}
					})
				})
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						// 请阅读勾选注册协议及隐私政策
						if (this.checkeds) {
							// 判断复选框是否被勾选 勾选则调用配置cookie方法
							if (this.checked) {
								// console.log(200)
								let password = Base64.encode(this.ruleForm.password) // base64加密
								localStorage.setItem('username', this.ruleForm.username)
								localStorage.setItem('password', password)
							} else {
								// console.log(404)
								localStorage.removeItem('username')
								localStorage.removeItem('password')
							}
							this.$axios({
								method: 'post', // 请求格式
								url: '/api/login/login', // 请求路径
								data: this.$data.ruleForm // 请求时携带的参数
							}).then(res => {
								if (res.data.code === 200) {
									// 将用户令牌存入cookie 并跳转只 首页
									this.$cookieStore.setCookie('token', res.data.data.token)
									this.$cookieStore.setCookie('userInfo', JSON.stringify(res.data.data
										.userInfo))
									if (res.data.data.userInfo.is_first == 2) {
										this.$message({
											message: res.data.msg,
											type: 'success',
											duration: 1000
										});
										this.$router.push('/')
									} else {
										this.$message({
											message: '请先给自己修改一个独一无二的头像和昵称，让同学和老师更容易记住你吧~',
											type: 'success',
											duration: 1000
										});
										this.$router.push('/PersonalEdit')
									}
								} else {
									// 这里表示的是用户登陆失败，比如 用户名密码输入错误
									this.$message.error(res.data.msg)
								}
							}).catch(() => {
								// 这里多半都是用户因为网络问题无法访问后端接口而调用的代码
								// console.log(error)
								this.$message.error('发送失败!')
							})
						} else {
							this.$message.error('请阅读勾选注册协议及隐私政策！')

						}
					} else {
						this.$message.error('提交错误！')
						// return
					}
				})
			},
			resetForm(formName) {
				this.$refs[formName].resetFields()
			}
		}
	}
</script>
<style scoped>
	/* 修改密码 */
	/deep/ .passCode {
		display: block;
	}

	/deep/ .passCode .el-input__inner {
		width: 250px !important;
		float: left;
	}

	.getCode {
		float: left;
		margin: 10px 0 0 20px;
		border-radius: 26px;
	}

	.back {
		float: right;
	}

	.circle {
		padding-top: 30px;
		margin: 0px;
		width: 1200px;
		margin: 0 auto;
	}

	.login {
		position: relative;
		left: 0px;
		top: 0px;
		width: 100%;
		height: 100vh;
		background: url('../assets/login-bg.jpg');
	}

	.you_shang {
		position: absolute;
		right: 0;
		top: 0;
		width: 270px;
		height: 155px;
	}

	.zhuo_xia {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 240px;
		height: 135px;
	}

	.deng_lu {
		width: 550px;
		height: 630px;
		box-sizing: border-box;
		position: absolute;
		top: 50%;
		right: 15vh;
		z-index: 2;
		transform: translate(0, -50%);
		background: white;
		border-radius: 20px;
	}

	.deng-lu-xuan-zhe {
		position: relative;
		margin: 100px 78px;
	}

	.yuan-cheng-jiao-yu {
		width: 275px;
		margin: auto;
		margin-bottom: 80px;
	}

	.logo {
		width: 100%;
		height: 100%;
	}

	.zhang-hao-deng-lu {
		width: 390px;
		height: 70px;
		color: #fff;
		font-size: 23px;
		background-color: #f6660b;
		border-radius: 35px;
		border: 0;
	}

	.zhang-hao-deng-lu span {
		font-size: 25px;
	}

	.deng_lu_kuang {
		width: 100%;
		height: 100%;
		margin: 0 auto;
		/* padding-top: 80px; */
		box-sizing: border-box;
	}

	.login-pass-title {
		font-size: 28px;
		color: #555556;
		font-weight: 500;
		text-align: left;
		display: block;
		margin-bottom: 30px;
	}

	.an_niu {
		margin: 15px 0 22px 0;
		width: 390px;
		height: 60px;
		font-size: 24px;
		border-radius: 35px !important;
		background-color: #f6660b;
		color: #fff;
		border: 0;
		margin-left: -100px;
	}

	.tong-yi {
		text-align: left;
		margin-left: 4px;
		margin-top: 20px;
	}

	.xue-yi {
		color: #f77b28;
		cursor: pointer;
		text-decoration: none;
	}

	.JiZhu {
		margin-top: -20px;
	}

	.zhao-hui-mi-ma {
		margin-left: 240px;
		color: #97999f;
		cursor: pointer;
	}

	.wei-xin-deng-lu {
		margin: auto;
		margin-top: 50px;
		margin-bottom: 55px;
		width: 390px;
		height: 70px;
		color: #fff;
		font-size: 23px;
		background-color: #83d326;
		border-radius: 35px;
		border: 0;
	}

	.wei-xin-deng-lu span {
		font-size: 27px;
	}

	.wx-login_div {
		line-height: 1.6;
		position: relative;
		display: inline-block;
		*display: inline;
		*zoom: 1;
		width: 100%;
		vertical-align: middle;
		z-index: 1;
		text-align: center;
	}

	.wx-login_div h3 {
		text-align: center;
		font-size: 20px;
	}

	.wx-login_div img {
		width: 280px;
		margin-top: 15px;
		margin-bottom: 15px;
		border: 1px solid #e2e2e2;
	}

	.wx-login_info {
		width: 280px;
		margin: 0 auto;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue